import React from "react";
import * as Lib from "../style/lib";
import * as OM from "../style/OmOss-style";
//import GroupAT from "../../assets/portraits/group-pink.png";
import { KontaktaOss } from "../utils/KontaktaOss";


const TextOmOss = [
  `Två vänner och tidigare kollegor startade Andtech med en gemensam vision. De hade tröttnat på de stora, stelbenta konsultbolagen där de alltför länge känt sig fastlåsta. Det var dags att göra något annorlunda – att skapa ett bolag där teknik och nyfikenhet får stå i centrum, utan hierarkier, förlegade processer och gamla sanningar som bromsar innovation och engagemang.`,

  `Idag är vi ett sammansvetsat team av nördiga, lösningsorienterade experter som brinner för att klura, förbättra och hitta smarta, hållbara lösningar som faktiskt gör skillnad.`,

  `För oss handlar det om att göra det svåra enkelt – att bygga system som är intuitiva att förstå, smidiga att jobba med och hållbara över tid.`,
  `Men vi vet också att teknik bara är ena halvan av ekvationen. Människor och relationer är minst lika viktiga. Vi tror på en schysst arbetskultur, där vi bryr oss om varandra och våra kunder – och där vi skapar långsiktigt värde på riktigt, inte bara snackar om det.
  Om ni letar efter en partner som tänker nytt, utmanar gamla arbetssätt och bygger smartare digitala lösningar – då är vi redo. Ska vi klura ihop?`
];

export const OmOss: React.FC = () => {

  
  return (
    <>
      <OM.OmOssContainer>
        <Lib.Headertop>Om oss</Lib.Headertop>
        <Lib.BigH1>Vilka är vi?</Lib.BigH1>
        <Lib.MainParagraph $textAlign="center">
          {`Vi är ett gäng nördiga och nyfikna experter. 
          Vårt mål är att hjälpa våra kunder att genomföra värdehöjande förbättringar.`}
        </Lib.MainParagraph>
        
        <OM.TeamGrid />

        {TextOmOss.map((text, index) => (
          <Lib.MainParagraph
            key={index}
            $margin={{ mobile: "10px 0", tablet: "10px 0", desktop: "12px 0" }}
          >
            {text}
          </Lib.MainParagraph>
        ))}
      </OM.OmOssContainer>
      <KontaktaOss />
    </>
  );
};
